"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
class NutritionModel {
    constructor(cache) {
        this.getNutritionProgressByDay = async (coachId, subscriptionId, dayNum) => {
            const nutritionDiaries = (await this.cache
                .getObject(NutritionModel.NUTRITION_DB)
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .asPromise());
            const diary = nutritionDiaries[coachId + "/" + subscriptionId];
            if (diary[dayNum] !== undefined) {
                return diary[dayNum];
            }
            throw new exception_1.OutOfRangeException("Item was not found");
        };
        this.set = (values) => this.cache.setObject(NutritionModel.NUTRITION_DB, values).asPromise();
        this.cache = cache;
    }
}
NutritionModel.NUTRITION_DB = "Mock.Database.NUTRITION_DB";
exports.default = NutritionModel;
//# sourceMappingURL=NutritionModel.js.map